import React from "react";
import { Button, Tooltip, OverlayTrigger, Image } from "react-bootstrap";

const NoteTooltip = () => {
  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip
            id="button-tooltip"
            className="in"
            style={{
              backgroundColor: "white",
              color: "black",
              borderRadius: "0.3rem",
            }}
          >
            <h3
              className="font-13 font-weight-s-bold"
              style={{ marginTop: 0, marginBottom: "5px" }}
            >
              Note:
            </h3>
            <div style={{ textAlign: "left" }}>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li className="font-12 font-weight-medium">
                  The password must be between 6 and 15 characters long
                </li>
                <li className="font-12 font-weight-medium">
                  The password must contains at least one character from the
                  following categories:
                </li>
                <li className="font-12 font-weight-medium">
                  English uppercase characters (A – Z)
                </li>
                <li className="font-12 font-weight-medium">
                  English lowercase characters (a – z)
                </li>
                <li className="font-12 font-weight-medium">
                  Base 10 digits (0 – 9)
                </li>
                <li className="font-12 font-weight-medium">
                  Non-alphanumeric (For example: !, $, #, or % etc)
                </li>
              </ul>
            </div>
          </Tooltip>
        }
      >
        <Button variant="none" className="border-0">
          <Image src="/assets/images/form-info.svg" />
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default NoteTooltip;
